import { Typography } from "@kaltura/ds-react-components";
import { translate } from "@kaltura/mediaspace-shared-utils";
import { NoPlaylistsIllustration } from "@kaltura/mediaspace-shared-ui";
import { AddToPlaylist, AddToPlaylistProps } from "../add-to-playlist/AddToPlaylist";
import { EmptyStateContainer, TextContainer } from "./styledComponents";

interface EmptyStateProps extends Omit<AddToPlaylistProps, "isSecondary"> {
    headingLevel: "h1" | "h2";
}

export const EmptyState = (props: EmptyStateProps) => {
    const { headingLevel, ...addToPlaylistProps } = props;

    return (
        <EmptyStateContainer className="kms-ds-edit-playlist-content-empty-state">
            <NoPlaylistsIllustration />
            <TextContainer>
                <Typography variant="h3" component={headingLevel}>
                    {translate("Add items to your playlist")}
                </Typography>
                <AddToPlaylist {...addToPlaylistProps} />
            </TextContainer>
        </EmptyStateContainer>
    );
};
